import React from 'react';
import PropTypes from 'prop-types';
import Spinner from './spinner';

class LoadingContainer extends React.Component {
  componentDidMount() {
    this.props.dispatch({
      type: 'route.mounted',
      route: this.props.route,
    });
  }

  render() {
    if (this.props.isLoading) {
      return (
        <div className="loadingContainer is-loading">
          <Spinner size="large" />
        </div>
      );
    }
    return (
      <div className="loadingContainer is-loaded">
        {this.props.children}
      </div>
    );
  }
}

LoadingContainer.propTypes = {
  isLoading: PropTypes.bool,
  route: PropTypes.string,
  dispatch: PropTypes.func,
};
LoadingContainer.defaultProps = {
  isLoading: false,
};

export default LoadingContainer;



// WEBPACK FOOTER //
// ./src/components/loading-container.js